import $ from "jquery";
import config from '../../lib/config';
import renderPosts from '../RenderPosts';

export default class LoadMore {

	static init() {

		let pagination = config.pagination.html();

		if ( typeof pagination != 'undefined' ) {
			// Hide the default Genesis pagination.
			config.pagination.remove();
		}

		if ( config.postsContainer.length > 0 && typeof pagination != 'undefined' ) {
			// Create the root directory for the additional posts.
			config.postsContainer.after('<section id="posts-root" class="react-root"></section>' );
			
			renderPosts.render();
		}
	}

}
